export const __ = (string) => {
    // return window.$$translations[string] || string;
    return window.wpmlTranslations?.[string] || string;
};

export const decodeHTMLEntities = (text) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
}

export const getLocalStorageKeys = () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const keyValues = token + '_formValues';
    const keyFragmentValues = token + '_formFragmentValues';

    return {
        keyValues,
        keyFragmentValues
    };
}

export const registrationID = () => {
    return Math.floor(Math.random() * Date.now()).toString(36);
};


export const isNumber = (evt) => {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
    } else {
        return true;
    }
}

export const isValidId = (id) => {
    id = String(id).trim();  
    if (id.length > 9 || isNaN(id)) return false;  
    id = id.length < 9 ? ("00000000" + id).slice(-9) : id;  
    return Array.from(id, Number).reduce((counter, digit, i) => {  
        const step = digit * ((i % 2) + 1);  
        return counter + (step > 9 ? step - 9 : step);  
    }) % 10 === 0;  
}

export const isLetter = (e) => {
	let char = e.key;
    if (/^\p{L}+$/u.test(char)) return true;
    else e.preventDefault(); 
}

export const blockLeadingSpace = (e) => {
    let char = e.key;
    let input = e.target;

    if (char === ' ' && input.selectionStart === 0) {
        e.preventDefault();
    } else {
        return true;
    }
}

export const formFragmentValues = () => JSON.parse(localStorage.getItem('formFragmentValues')) || {}

export const setFormFragmentValues = (values) => {
    const getFormFragmentValues = formFragmentValues();
    localStorage.setItem('formFragmentValues', JSON.stringify({
        ...getFormFragmentValues,
        ...values
    }));
}

export const getFormValuesFromLocalStorage = () => {
    const defaultValues = {
        subscriberAddressType: "byAddress",
        companyAddressType: 'byAddress',
    }
    const parseLocalValues = JSON.parse(localStorage.getItem('formValues')) || {};

    return {
        ...defaultValues,
        ...parseLocalValues
    };
}


export const setFormValues = (values) => {
    const formValues = getFormValuesFromLocalStorage();
    localStorage.setItem('formValues', JSON.stringify({
        ...formValues,
        ...values
    }));
} 

export const clearDash = (str) => str?.replace(/-/g, '');

export const registrationInfo = (data, lead_id = '') => {
    const clientType = data.activeTab === 'Business Client' ? 'company' : 'subscriber';
    const account_type = data.activeTab === 'Business Client' ? 'business' : 'private';

    const RequestID = retrieveUrlParameter('PrivateRequestID')
    const paymentPageStatus = retrieveUrlParameter('page_status')
    const localValues = formFragmentValues();
    const leadId = sessionStorage.getItem('lead_id');
 
    const userData = {
        "first_name": data[`${clientType}FirstName`],
        "last_name": data[`${clientType}LastName`],
        "account_type": account_type,
        "phone_office": clearDash(data[`${clientType}Phone`]),
        "email": data[`${clientType}Email`],
        "personal_id": data[`${clientType}ID`],
        "subscribers": [],
        "intl_operator": data.internationalOperator,
        "invoice_shipping_method": data.selectedInvoice,
        "agree_newsletter": data.terms,
        "agree_terms": data.terms,
        "agree_ownership": data.terms,
        "zip_code": data[`zipCode`],
        "shipment_address": [],
        "lead_id": leadId,
        "registration_id": localValues.registrationID,
    }
 
    if (data?.paymentGateway?.length){
        userData.use_existing_payment_gateway = true;
    }else{
        userData.payment_details = {
            "status": paymentPageStatus,
            "PrivateRequestID": RequestID
        }
    }

    const hasNonEsim = data.phoneNumbers.some(phone => phone.sim_type !== "esim");

    if (hasNonEsim){
        userData.shipment_method = data[`${clientType}ShippingMethod`];
    }


    if(data['account_id']) {
        userData.account_id = data['account_id'];
    }

    if (data[`${clientType}AddressType`] === 'byAddress') {
        userData.city_code = data[`${clientType}CityCode`];
        userData.house_number = data[`${clientType}NumberHome`];
        userData.house_enter = data[`${clientType}Entrance`];
        userData.floor = data[`${clientType}Floor`];
        userData.apartment_number = data[`${clientType}Apartment`];
        userData.street_code = data[`${clientType}StreetCode`];
    } else {
        userData.city_code = data[`${clientType}POCityCode`];
        userData.mailbox = data[`${clientType}PO`];
    }


    data.phoneNumbers?.forEach(phoneNumber => {
        userData.subscribers.push({
            "phone_number": clearDash(phoneNumber.number),
            "phone_id": !phoneNumber.ported ? phoneNumber.phone_id : "",
            "plan_id": phoneNumber.plan,
            "sim_type": phoneNumber.sim_type,
            "ported": phoneNumber.ported,
        });
    });

    if (!data[`${clientType}SendSimToAddress`]) {
        if(data[`${clientType}AddressType`] !== 'byPO'){
            userData.shipment_address.push({
                "city_code": data[`${clientType}ShippingCityCode`],
                "street_code": data[`${clientType}ShippingStreetCode`],
                "zip_code": data[`${clientType}ShippingzipCode`],
                "house_number": data[`${clientType}ShippingNumberHome`],
                "house_enter": data[`${clientType}ShippingEntrance`],
                "floor": data[`${clientType}ShippingFloor`],
                "apartment_number": data[`${clientType}ShippingApartment`]
            });

        }
    } else {
        userData.shipment_address.push({
            "city_code": data[`${clientType}CityCode`],
            "street_code": data[`${clientType}StreetCode`],
            "zip_code": data[`${clientType}zipCode`],
            "house_number": data[`${clientType}NumberHome`],
            "house_enter": data[`${clientType}Entrance`],
            "floor": data[`${clientType}Floor`],
            "apartment_number": data[`${clientType}Apartment`]
        });
    }
    return userData;
};

export const requestSimActivation = async (values) => {
	const newDataJsonString = JSON.stringify(values);

	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=activate_sim_card&simData=${newDataJsonString}`,
	})
		.then(response => response.json())
}

export const validateOTP = async (values) => {
	const newDataJsonString = JSON.stringify(values);

	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=validate_otp_code&validationData=${newDataJsonString}`,
	})
		.then(response => response.json())
}

export const getAccountByNumber = async (values) => {
	const newDataJsonString = JSON.stringify(values);


	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=get_account_by_phone&phoneData=${newDataJsonString}`,
	})
		.then(response => response.json())
}

export const requestPaymentURL = async (page = 'steps') => {

	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=app_get_payment_url&target_page=${page}`,
	})
		.then(response => response.json())
}

export const requestRegularShippingPrice = async () => {

	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=app_get_regular_shipping_price`,
	})
		.then(response => response.json())
}


export const requestFastShippingPrice = async () => {

	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=app_get_fast_shipping_price`,
	})
		.then(response => response.json())
}

export const requestRegistrationFormFields = async () => {

	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=app_get_registration_form_fields`,
	})
		.then(response => response.json())
}

export const requestPlanCTP = async () => {

	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=app_get_telecom_plans_cpt`,
	})
		.then(response => response.json())
}

export const requestPlanCTPbyID = async (id) => {

	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=app_get_telecom_plan_cpt_by_id&picked_id=${id}`,
	})
		.then(response => response.json())
}


export const requestSearchedRoamingPlans = async (mcc = '', usage_type = '', location_type = '') => {

    const searchQuery = {
		'mcc': mcc,
        'usage_type': usage_type,
        'location_type': location_type,
	}; 

	const searchDataJsonString = JSON.stringify(searchQuery);

    return fetch(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=get_searched_roaming_plan&roaming_data=${searchDataJsonString}`,
    })
    .then(response => response.json())            
};

export const requestAvailableMsisdns = async () => {

	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=app_get_available_numbers`,
	})
		.then(response => response.json())
}

export const requestAvailableCities = async (city_name = '') => {
    
    return fetch(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_get_cities_by_name&city_name=${city_name}`,
    })
    .then(response => response.json());
};

export const requestAvailableStreets = async (city_code, street_name = '') => {

    const streetData = {
		'city_code': city_code,
        'street_name': street_name,
	};

	const streetDataJsonString = JSON.stringify(streetData);

    return fetch(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=get_streets&street_data=${streetDataJsonString}`,
    })
    .then(response => response.json())            
};

export const onlyHebrew = (e) => {
    const allowedChars = "אבגדהוזחטיכלמנסעפצקרשת ";
    const char = e.key;
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Tab", "Control", "Meta", "v"];

    const allowCombination = ['c', 'v', 'a']

    for(let i = 0; i < allowCombination.length; i++) {
        if (e.ctrlKey && char.toLowerCase() === allowCombination[i] || e.metaKey && char.toLowerCase() === allowCombination[i]) {
            return;
        }
    }

    if (!allowedChars.includes(char) && !allowedKeys.includes(char)) {
        e.preventDefault();
    }
}

export const onlyEnglish = (e) => {
    const allowedChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.@ ";
    const char = e.key;
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Tab", "Control", "Meta"];
  
    const allowCombination = ['c', 'v', 'a', 'x'];
  
    for(let i = 0; i < allowCombination.length; i++) {
      if ((e.ctrlKey || e.metaKey) && char.toLowerCase() === allowCombination[i]) {
        return;
      }
    }
  
    if (!allowedChars.includes(char) && !allowedKeys.includes(char)) {
      e.preventDefault();
    }
}

export const onlyEnglishAndNumbers = (e) => {
    const allowedChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789.@ ";
    const char = e.key;
    const allowedKeys = [
        "Backspace", "Delete", "ArrowLeft", "ArrowRight", 
        "ArrowUp", "ArrowDown", "Tab", "Control", "Meta"
    ];

    const allowCombination = ['c', 'v', 'a', 'x'];

    for (let i = 0; i < allowCombination.length; i++) {
        if ((e.ctrlKey || e.metaKey) && char.toLowerCase() === allowCombination[i]) {
            return;
        }
    }

    if (!allowedChars.includes(char) && !allowedKeys.includes(char)) {
        e.preventDefault();
    }
}


export function decodeHtmlEntities(str) {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
}

export async function getZipCode(clientType, sendSimToAddress = false) {
    const data = getFormValuesFromLocalStorage(); 

    //const clientType = data.activeTab === 'Business Client' ? 'company' : 'subscriber';
    let zipCodeType = clientType + 'zipCode';
    let cityCode = data[`${clientType}CityCode`];
    let streetCode = data[`${clientType}StreetCode`];
    let houseNumber = data[`${clientType}NumberHome`];
    let houseEntrance = data[`${clientType}Entrance`]

    if (data[`${clientType}AddressType`] !== 'byAddress') {
        cityCode = data[`${clientType}POCityCode`];
    }

    if (sendSimToAddress) {
        cityCode = data[`${clientType}CityCode`];
        streetCode = data[`${clientType}StreetCode`];
        houseNumber = data[`${clientType}NumberHome`]
        houseEntrance = data[`${clientType}Entrance`]
        zipCodeType = clientType + 'ZipCode';
    } 

    const addressData = {
		'city_code': cityCode || '',
        'street_code': streetCode || '',
        'house_number': houseNumber || '',
        'house_entrance': houseEntrance || '',
	};

    if (addressData.city_code.length === 0 || addressData.street_code.length === 0) {
        return;
    }

	const addressDataJsonString = JSON.stringify(addressData);

    return fetch(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=get_address_zipcode&address_data=${addressDataJsonString}`,
    })
    .then(response => response.json())
}

export function requestZipCode(data) {
    const dataJSON = JSON.stringify(data);
    return request(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=get_address_zipcode&address_data=${dataJSON}`,
    })
}

export function retrieveUrlParameter(param,currentUrl = window.location.href){
    // const currentUrl = window.location.href;
    const url = new URL(currentUrl);

    // Create a URLSearchParams object from the query string
    const params = new URLSearchParams(url.search);

    // Check if the parameter exists
    if (params.has(param)) {
        const paramValue = params.get(param);
        return paramValue;
    }

    return false;
}

export function getHashParams(param){
    const hash = window.location.hash;
    const queryIndex = hash.indexOf('?'); 
    if (queryIndex !== -1) {
      const queryParams = new URLSearchParams(hash.substring(queryIndex + 1));
      return queryParams.get(param);
    }
  };

export function updateURL(value) {
    const newUrl = window.location.origin + window.location.pathname + window.location.search + value;
    history.replaceState(null, '', newUrl);
}

export function checkIfOnlyEsim() {
    const savedFields = getFormValuesFromLocalStorage();
    
    if (!Array.isArray(savedFields.phoneNumbers)) {
        return false;
    }
    return savedFields.phoneNumbers.every(phoneNumber => phoneNumber.sim_type !== 'sim');
}

export function requireShipping() {
    const savedFields = getFormValuesFromLocalStorage();

    if (savedFields?.existingAccount){
        return false;
    }

    return true;
}

export async function requestTranslations() {
    return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=app_get_vue_js_translations`,
	})
		.then(response => response.json())
};

export function getCookie(cname) {
	let name          = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca            = decodedCookie.split(';');

	for(let i = 0; i < ca.length; i++) {
		let c = ca[i];

		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}

		if (c.indexOf(name) == 0) {
			return decodeURIComponent(c.substring(name.length, c.length));
		}
	}

	return "";
}

export function finishRegistrationIsSuccess(data) {
    if (typeof data.response?.status !== 'undefined' && data.response?.status === false) {
        return false;
    }

    return true;
}

export const requestSelfcareAccountDetails = async (token) => {

	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=app_selfcare_account_details&details_token=${token}`,
	})
		.then(response => response.json())
}


export async function getSelfcareAccountLogin({personal_id, sms_validation, type}) {

    const accountInfo = {
		'personal_id': personal_id || '',
        'sms_validation': sms_validation || '',
        'type': type || '',
	};

	const accountInfoJsonString = JSON.stringify(accountInfo);

    return fetch(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_get_selfcare_account_login&login_info=${accountInfoJsonString}`,
    })
    .then(response => response.json())
}

export async function request(url, options) {
    try {
        const data = await fetch(url, options).then(response => response.json());
        return [data, null]
    } catch (error) {
        console.log(error);
        return [null, error]
    }
}

export const requestSelfcareAccountDocuments = async (token) => {

	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=app_selfcare_account_documents&doc_token=${token}`,
	})
		.then(response => response.json())
}

export const requestSelfcareLocalDataServices = async (token) => {

	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=app_selfcare_local_data_services&services_token=${token}`,
	})
		.then(response => response.json())
}

export const requestSelfcareRoamingDataServices = async (token) => {

	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=app_selfcare_roaming_data_services&roaming_token=${token}`,
	})
		.then(response => response.json())
}

export async function SelfcareAccountChangeDetails(details) {
    const detailsInfo = {
		'first_name': details['first_name'] || '',
        'last_name': details['last_name'] || '',
        'city_code': details['city_code'] || '',
        'street_code': details['street_code'] || '',
        'zip_code': details['zip_code'] || '',
        'house_number': details['house_number'] || '',
        'house_enter': details['house_enter'] || '',
        'floor': details['floor'] || '',
        'apartment_number': details['apartment_number'] || '',
        'email': details['email'] || '',
        'phone': details['phone'] || '',
	};


	const accountInfoJsonString = JSON.stringify(detailsInfo);

    return fetch(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_get_selfcare_account_change_details&details_info=${accountInfoJsonString}`,
    })
    .then(response => response.json())
}

export async function requestSelfcareAccountSubscriber(subscriber_id) {

    const subscriber = subscriber_id || '';

    return request(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_selfcare_account_subscriber&subscriber_id=${subscriber}`,
    })
}

export async function SelfcareAccountSubscriberAddService($token, details) {

    const detailsInfo = {
        'token': $token,
		'subscriber_id': details['subscriber_id'] || '',
        'product_id': details['product_id'] || '',
        'days_amount': details['days_amount'] || '',
        'start_date': details['start_date'] || '',
	};

	const accountInfoJsonString = JSON.stringify(detailsInfo);

    return fetch(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_get_selfcare_account_subscriber_add_service&sub_add_service=${accountInfoJsonString}`,
    })
    .then(response => response.json())
}

export async function SelfcareAccountSubscriberChangePlan($token, plan) {

    const planInfo = {
        'token': $token,
		'subscriber_id': plan['subscriber_id'] || '',
        'plan_id': plan['plan_id'] || '',
	};

	const planInfoJsonString = JSON.stringify(planInfo);

    return fetch(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_get_selfcare_account_subscriber_change_plan&change_plan=${planInfoJsonString}`,
    })
    .then(response => response.json())
}

export async function SelfcareAccountSubscriberUsage(usage) {

    const planUsage= {
		'msisdn': usage['msisdn'] || '',
        'date_range': usage['date_range'] || '',
        'type' : usage['type'] || ['call', 'data', 'sms']
	};

	const planUsageJsonString = JSON.stringify(planUsage);

    return fetch(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_get_selfcare_account_subscriber_usage&show_usage=${planUsageJsonString}`,
    })
    .then(response => response.json())
}

export async function SelfcareRequestDocumentDownload(documentID) {
    return fetch(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_get_selfcare_download_document&document_id=${documentID}`,
    })
    .then(response => response.json())
}

export async function SelfcareRequestInvoiceDownload(documentID) {
    return fetch(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_get_selfcare_download_invoice&invoice_id=${documentID}`,
    })
    .then(response => response.json())
}

export const handleNameField = (e) => {
    let char = e.key;
    let input = e.target.value;

    if(input === '' && char === ' ') {
        e.preventDefault()
        return;
    } else if(input != '' && char === ' ') {
        return true;
    }

    if (/^\p{L}+$/u.test(char)) return true;
    else e.preventDefault(); 
}

export const handleNameFieldPaste = (event) => {
    setTimeout(() => {
        event.target.value = event.target.value.replace(/\d/g, '');
        event.target.dispatchEvent(new Event('input', { bubbles: true }));
    }, 0);
}

export const handleNumberFieldPaste = (event) => {
    setTimeout(() => {
        let inputValue = event.target.value;

        if (inputValue.includes('-')) {
            inputValue = inputValue.slice(0, 11);
        } else {
            inputValue = inputValue.slice(0, 10);
        }

        event.target.value = inputValue;
        event.target.dispatchEvent(new Event('input', { bubbles: true }));
    }, 0);
};

export const inputValidEmail = (event) => {
    const regex = /^[a-zA-Z0-9@._-]*$/;
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
}

export const handleLeadQuery = () => {
    const url = new URL(window.location.href);
    const lead = url.searchParams.get("lead");

    if(lead) {
        sessionStorage.setItem('lead_id', lead);
        const params = url.searchParams;
        params.delete('lead');
        const newUrl = `${url.origin}${url.pathname}?${params.toString()}${url.hash}`;
        history.replaceState(null, '', newUrl);
    }
}

export const getDocuments = (url) => {
    return request(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_selfcare_account_documents`,
    })
}

export const getInvoices = () => {
    return request(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_selfcare_account_invoices`,
    })
}

export const requestPaymentUpdate = (status, PrivateRequestID) => {

    const paymentDetails = {
        'status': status,
		'PrivateRequestID': PrivateRequestID,
	};

	const paymentDetailsJsonString = JSON.stringify(paymentDetails);
    

    return request(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_selfcare_payment_update&payment_info=${paymentDetailsJsonString}`,
    })
}

export function setCookie(cname, cvalue, exdays) {
	const d = new Date();

	d.setTime( d.getTime() + ( exdays*24*60*60*1000 ) );

	let expires = "expires=" + d.toUTCString();

	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function requestPostNewLead(payload) {
    return request(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_post_new_lead&data=${payload}`,
    })
}

export function convertArrayToObject(response) {
    if(Array.isArray(response) && response.length === 1) {
        return response[0];
    }

    return response;
}

export function formatBytes(bytes, decimals = 2) {
    if (!+bytes) {
        return {
            endValue: 0,
            unit: 'Bytes'
        }
    }

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return {
      endValue: parseFloat((bytes / Math.pow(k, i)).toFixed(dm)),
      unit: sizes[i]
    }
}

export function formatBytesToGigabytes(bytes, decimals = 2) {
    if (!+bytes) {
        return {
            endValue: 0,
            unit: 'GB'
        }
    }

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    
    // Convert directly to GB (k^3)
    const gbValue = bytes / Math.pow(k, 3)
    
    return {
      endValue: parseFloat(gbValue.toFixed(dm)),
      unit: 'GB'
    }
}

export function formatDate(dateString){
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

export const maskPhoneNumber = (phoneNumber) => {
    if (phoneNumber.length <= 6) {
        return phoneNumber;
    }
    const firstThree = phoneNumber.slice(0, 3);
    const lastThree = phoneNumber.slice(-3);
    const maskedSection = '*'.repeat(phoneNumber.length - 6);
    return `${firstThree}${maskedSection}${lastThree}`;
};

export const sendCellularData = () => {
    const savedFields = getFormValuesFromLocalStorage();

    const clientType = savedFields.activeTab === 'Business Client' ? 'company' : 'subscriber';

    if (typeof dataLayer !== 'undefined' && typeof dataLayer.push === 'function') {
        const data = {
            event: "purchase",
            ecommerce: {
                idnt_phone: savedFields[`${clientType}Phone`],
                idnt_email: savedFields[`${clientType}Email`],
                idnt_first_name: savedFields[`${clientType}FirstName`],
                idnt_last_name: savedFields[`${clientType}LastName`],
                idnt_country: "Israel",
                currency: "ILS",
                value: savedFields["totalPrice"],
                tax: "",
                shipping: savedFields["shippingPrice"],
                transaction_id: "",
                coupon: "",
                funnel: "cellular_plans",
                items: []
            }
        }

        savedFields.phoneNumbers?.forEach(phoneNumber => {
            data.ecommerce.items.push({
                "item_name": phoneNumber.plan_name,
                "item_id": phoneNumber.plan,
                "item_variant": phoneNumber.sim_type,
                "quantity": 1,
                "coupon": "",
                "discount": "",
                "price": phoneNumber.plan_price,
            });
        });

        dataLayer.push(data);
    }
}

export const sendAbroadData = () => {

    const savedFields = getFormValuesFromLocalStorage();
    const roamingPlan = JSON.parse(localStorage.getItem('formRoaming'));

    if (typeof dataLayer !== 'undefined' && typeof dataLayer.push === 'function') {
        const data = {
            event: "purchase",
            ecommerce: {
                idnt_phone: savedFields?.roamingCustomerNumber,
                idnt_email: "",
                idnt_first_name: roamingPlan?.account_first_name,
                idnt_last_name: "",
                idnt_country: "Israel",
                currency: "ILS",
                value: "",
                tax: "",
                shipping: "",
                transaction_id: "",
                coupon: "",
                funnel: "abroad",
                items: [
                    {
                        item_name: roamingPlan?.description,
                        item_id: roamingPlan?.product_id,
                        item_category: roamingPlan?.name_heb,
                        coupon: "",
                        discount: "",
                        price: roamingPlan?.price,
                        quantity: 1,
                        item_variant: ""
                    }
                ]
            }
        }

        dataLayer.push(data);
    }
}

export const formatDuration = (durationInSeconds) => {
    if (durationInSeconds < 0) durationInSeconds = 0;

    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = durationInSeconds % 60;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

// Helper function to format byte sizes
export const byteFormat = (bytes, decimals = 2, showSize = true) => {
    if (bytes === 0) return '0' + (showSize ? ' Bytes' : '');
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = [__('Bytes'), __('KB'), __('MB'), __('GB'), __('TB')];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + (showSize ? ' ' + sizes[i] : '');
};


export const numbersType = (numbers) => {
    let hasPorted = false;
    let hasNewLine = false;

    numbers?.forEach(phoneNumber => {
        if (phoneNumber.is_ported) {
            hasPorted = true;
        } else {
            hasNewLine = true;
        }
    });

    if (hasPorted && hasNewLine) {
        return "mixed";
    }



    if (hasPorted) return "ported";
    if (hasNewLine) return "new_line";

    return null;
};

export const getMonthString = (monthNumber) => {

    const monthNames = [
        __("January"), __("February"), __("March"), __("April"), __("May"), __("June"),
        __("July"), __("August"), __("September"), __("October"), __("November"), __("December")
    ];

    return monthNames[monthNumber];
}

export const selfcareSendOTPCode = async (personal_id, type) => {

	return fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=selfcare_send_otp_code&personal_id=${personal_id}&type=${type}`,
	})
		.then(response => response.json())
}

const getDocumentURL = async (id) => {
    let responseURL = ''; 

    try {
        const response = await SelfcareRequestDocumentDownload(id);
        if(response) {
            const responseData = JSON.parse(response.data);

            if (responseData?.response?.data) {
                responseURL = responseData.response.data;
            }
        }

    } catch (error) {
        console.error('Error fetching document URL:', error);
    }

    return responseURL;
};

const getInvoiceURL = async (id) => {
    let responseURL = ''; 

    try {
        const response = await SelfcareRequestInvoiceDownload(id);
        if(response) {
            const responseData = JSON.parse(response.data);

            if (responseData?.response?.data) {
                responseURL = responseData.response.data;
            }
        }

    } catch (error) {
        console.error('Error fetching Invoice URL:', error);
    }

    return responseURL;
};


export const handleDocumentClick = (id, documentURL = true) => {
    // 1. Open popup immediately during user click
    const newWindow = window.open("", "_blank");
    if (!newWindow) {
        alert("Please allow popups to view this document.");
        return;
    }

    // 2. Run the async logic AFTER popup is already open
    (async () => {
        const url = documentURL
            ? await getDocumentURL(id)
            : await getInvoiceURL(id);

        if (!url) {
            newWindow.document.write("Unable to load document");
            return;
        }

        const byteCharacters = atob(url);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const pdfUrl = URL.createObjectURL(blob);

        // 3. Redirect the window once PDF is ready
        newWindow.location.href = pdfUrl;
    })();
};

export function downloadCSV(jsonData) {
    const headings = jsonData.headings.map(item => item.replace(',', '')).join(",") + "\n";
    const footers = jsonData.footers.map(item => item.replace(',', '')).join(",") + "\n";
    
    const dataRows = jsonData.data.map(row => {
        const rate = row.rate.replace(',', '');
        return `${row.date},${row.time},${rate},${row.target},${row.usage},${row.amount}`;
    }).join("\n") + "\n";
    
    const csvContent = "\uFEFF" + headings + dataRows + footers;

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${jsonData.label}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export const requestShipmentChange = (data) => {
    return request(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_selfcare_account_shipment_method&shipment_method=${data}`,
    })
}

export const currentMonth = () => {
    const currentDate = new Date();
    const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    const startDate = dateInWebhookFormat(startOfMonth);
    const endDate = dateInWebhookFormat(endOfMonth);

    return `${startDate},${endDate}`;
}

const dateInWebhookFormat = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const requestAccountSession = () => {

    return request(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_get_account_session`,
    })
}

export const sortDates = (start, end) => {
    let fromRange = start;
    let toRange = end;

    if(fromRange > toRange) {
        fromRange = end;
        toRange = start;
    }

    return [
        fromRange,
        toRange
    ]
}

export const convertSecondsToMinutes = (seconds) => {
    return Math.floor(seconds / 60);
}

export const convertEpochToLocalDate = (epoch) => {
    const date = new Date(epoch * 1000);
    return date.toLocaleDateString("en-GB");
}

export async function SelfcareAccountSubscriberLineManagment(data) {
    const ncData = JSON.stringify(data);

    return fetch(ajax_object.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `action=app_selfcare_account_subscriber_line_managment&nc_data=${ncData}`,
    })
    .then(response => response.json())
}
